import create from 'zustand';

import type { Place } from '0_canvas/Tiles/geo';
import type { TileInfo } from '0_canvas/Tiles/loader';

interface TilesState {
  place: Place | null;
  tiles: TileInfo[];
  attribution: string[] | null;
  setPlace: (place: Place | null) => void;
  setTiles: (tiles: TileInfo[]) => void;
  setAttribution: (attr: string[]) => void;
}

const useTilesStore = create<TilesState>(set => ({
  place: null,
  tiles: [],
  attribution: null,
  setPlace: place => set({ place }),
  setTiles: tiles => set({ tiles }),
  setAttribution: attr => set({ attribution: attr }),
}));

export default useTilesStore;
